import $ from 'cash-dom';

$('#gBody').on('click', '.go_m_red', function () {
    var pageID = $(this).data('mid');
    var win = window.open(goGlobal.WEB_URL + 'load/store/?go=' + pageID, "_blank");
    if (win) {
        win.focus();
    }
});
